import { ENV } from './environments';

export enum Regions {
    WORLD = 'WORLD',
    CHINA = 'CHINA'
}

export const UBI_SERVICES_ADMIN_ENDPOINT = {
    [ENV.DEV]: 'https://uat-admin-ubiservices.ubi.com',
    [ENV.PROD]: 'https://admin-ubiservices.ubi.com'
};

export const UBI_SERVICES_ENDPOINT = {
    [ENV.DEV]: 'https://uat-public-ubiservices.ubi.com',
    [ENV.PROD]: 'https://public-ubiservices.ubi.com'
};

export const UBI_EVENTS_ENDPOINT = {
    [ENV.DEV]: 'https://uat-beta.ubi.com',
    [ENV.PROD]: 'https://beta.ubi.com'
};

export const FRIENDS_REFERRAL_ENDPOINT = {
    [ENV.DEV]: 'https://uat-referral.ubi.com',
    [ENV.PROD]: 'https://referral.ubi.com'
};

export const UPLAY_CLIENT_ENDPOINT = {
    [Regions.WORLD]: {
        [ENV.DEV]: 'https://uat-redeemstarter-public.ubi.com',
        [ENV.PROD]: 'https://redeemstarter-public.ubi.com'
    },
    [Regions.CHINA]: {
        [ENV.DEV]: 'https://uat-redeemstarter-public.ubi.cn',
        [ENV.PROD]: 'https://redeemstarter-public.ubi.cn'
    }
};
